import React from "react";
import ReactDOM from "react-dom/client";
// import { useState } from "react";
import './index.css';
import App from './App';
// import StarRating from "./StarRating";

// function Test() {
//   const [movieRating, setMovieRating] = useState(0);

//   return (
//     <div>
//       <StarRating color="blue" maxRating={10} onSetRating={setMovieRating} />
//       <p>This movie was rated {movieRating} stars</p>
//     </div>
//   );
// }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    {/* <StarRating
      maxRating="5"
      messages={["Terrible", "Bad", "Okay", "Good", "Amazing"]}
    />
    <StarRating
      maxRating={5}
      size={72}
      color="gold"
      className="test"
      defaultRating={3}
      messages={["😞", "😕", "😊", "😄", "😍"]}
    /> */}
    {/* <Test /> */}
  </React.StrictMode>,
);
